// 岗位类型统一定义 —— 修改此处即可影响全部前端展示
export const JOB_TYPE_OPTIONS = [
  { value: 'overseas-market',  label: '国内负责海外市场', short: '负责海外市场' },
  { value: 'global-market',    label: '国内负责全球市场', short: '负责全球市场' },
  { value: 'foreign-domestic', label: '国内外资企业',     short: '国内外资' },
  { value: 'expat',            label: '外派',             short: '外派' },
  { value: 'local-hire',       label: '海外本地招聘',     short: '海外本地' },
];

export const JOB_TYPE_LABELS = JOB_TYPE_OPTIONS.reduce((acc, o) => {
  acc[o.value] = o.label;
  return acc;
}, {});

export const JOB_TYPE_SHORT = JOB_TYPE_OPTIONS.reduce((acc, o) => {
  acc[o.value] = o.short;
  return acc;
}, {});

export function jobTypeLabel(v) { return JOB_TYPE_LABELS[v] || v || ''; }
export function jobTypeShort(v) { return JOB_TYPE_SHORT[v] || v || ''; }
